import React, { useEffect } from "react";
import Lenis from "@studio-freight/lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import StatsStrip from "./components/StatsStrip";
import Services from "./components/Services";
import About from "./components/About";
import BrandMeaning from "./components/BrandMeaning";
import HowItWorks from "./components/HowItWorks";
import Testimonials from "./components/Testimonials";
import Faq from "./components/Faq";
import Disclaimer from "./components/Disclaimer";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Admin from "./pages/Admin";
import InvoicePay from "./pages/InvoicePay";
import Chat from "./pages/Chat";
import Roadmap from "./pages/Roadmap";
import Community from "./pages/Community";
import PaymentReturn from "./pages/PaymentReturn";
import Book from "./pages/Book";
import BookManage from "./pages/BookManage";
import VideoVisit from "./pages/VideoVisit";
import InterpreterAvailability from "./pages/InterpreterAvailability";
import Clinic from "./pages/Clinic";
import Learn from "./pages/Learn";
import AdSection from "./components/AdSection";
import InstallPrompt from "./components/InstallPrompt";
import { LanguageProvider } from "./i18n/LanguageContext";

function MarketingSite() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    const id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App font-sans" data-testid="app-root">
      <Header />
      <main>
        <Hero />
        <StatsStrip />
        <AdSection />
        <Services />
        <About />
        <BrandMeaning />
        <HowItWorks />
        <Testimonials />
        <Faq />
        <Disclaimer />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/admin" element={<Admin />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/community" element={<Community />} />
          <Route path="/community/:groupId" element={<Community />} />
          <Route path="/portal" element={<Community />} />
          <Route path="/payment/success" element={<PaymentReturn />} />
          <Route path="/payment/cancel" element={<PaymentReturn />} />
          <Route path="/book" element={<Book />} />
          <Route path="/book/manage" element={<BookManage />} />
          <Route path="/pay/:token" element={<InvoicePay />} />
          <Route path="/video-visit/:id" element={<VideoVisit />} />
          <Route path="/interpreter/:token" element={<InterpreterAvailability />} />
          <Route path="/clinic" element={<Clinic />} />
          <Route path="/learn" element={<Learn />} />
          <Route path="/roadmap" element={<Roadmap />} />
          <Route path="/" element={<MarketingSite />} />
        </Routes>
        <InstallPrompt />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
